import {
  regNumberRegex,
} from '@/helpers/products/car';
import {
  REG_NUMBER_MIN,
  REG_NUMBER_MAX_CHARACTERS,
} from '@/inputCharsLimiters/common';

export default {
  validate: value => {
    const trimmedValueLength = value.replace(/\s+/g, '').length;
    if (!value) return true;
    if (!regNumberRegex.test(value)) {
      return 'Invalid registration format. This should only consist of letters, numbers and spaces.';
    }
    if (trimmedValueLength < REG_NUMBER_MIN || trimmedValueLength > REG_NUMBER_MAX_CHARACTERS) {
      return `Registration number must be between ${REG_NUMBER_MIN} and ${REG_NUMBER_MAX_CHARACTERS} characters.`;
    }
    return true;
  },
};
